define( function() {
	return ( /\S+/g );
} );



//////////////////
// WEBPACK FOOTER
// /~/jquery/src/var/rnotwhite.js
// module id = 269
// module chunks = 0